import { NgModule } from '@angular/core';
import { CommonModule, DecimalPipe } from '@angular/common';
import { CustomItemSelectorComponent } from './custom-item-selector.component';
import { CustomDialogModule } from '../custom-dialog/custom-dialog.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CustomDropDownListModule } from '../custom-drop-down-list/custom-drop-down-list.module';
import { MatSelect, MatSelectModule } from '@angular/material/select';



@NgModule({
  declarations: [
    CustomItemSelectorComponent,
  ],
  imports: [
    CommonModule,
    CustomDialogModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    CustomDropDownListModule,
    MatSelectModule
  ],
  exports: [
    CustomItemSelectorComponent,
  ],
  providers: [
    DecimalPipe,
  ]
})
export class CustomItemSelectorModule { }
